import { useState } from 'react';
import { formatGel, formatNumber } from '../lib/format';
import { useI18n } from '../lib/i18n';
import { useReferral } from '../lib/queries';
import { Amount, Card } from './ui';

export function ReferralCard() {
  const { t, language } = useI18n();
  const { data } = useReferral();
  const [copied, setCopied] = useState(false);

  if (!data?.enabled || !data.code) return null;

  const reward = data.rewardCashbackTetri > 0
    ? <Amount value={formatGel(data.rewardCashbackTetri, language)} className="text-positive" />
    : data.rewardPoints > 0
      ? <span className="tabular text-positive">{formatNumber(data.rewardPoints, language)}</span>
      : null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(data.code!);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard access can be refused; the code is on screen to read out.
    }
  };

  return (
    <Card>
      <h2 className="mb-1 text-[0.68rem] font-semibold uppercase tracking-[0.18em] text-ink-faint">
        {t('referral.title')}
      </h2>
      <p className="mb-3 text-xs leading-relaxed text-ink-dim">{t('referral.hint')}</p>

      <div className="rounded-2xl border border-brand/30 bg-brand-wash px-4 py-3 text-center">
        <div className="tabular text-2xl font-bold tracking-[0.2em] text-brand">{data.code}</div>
      </div>

      <button
        onClick={copy}
        className="mt-2 min-h-11 w-full rounded-xl border border-line text-sm font-semibold text-ink-dim transition-colors hover:border-brand/40 hover:text-ink"
      >
        {copied ? t('referral.copied') : t('referral.copy')}
      </button>

      <dl className="mt-3 grid grid-cols-3 gap-2 border-t border-line pt-3 text-center">
        <div>
          <dt className="text-[0.6rem] uppercase tracking-wider text-ink-faint">
            {t('referral.joined')}
          </dt>
          <dd className="tabular mt-0.5 text-base font-semibold text-ink">
            {formatNumber(data.joined, language)}
          </dd>
        </div>
        <div>
          <dt className="text-[0.6rem] uppercase tracking-wider text-ink-faint">
            {t('referral.rewarded')}
          </dt>
          <dd className="tabular mt-0.5 text-base font-semibold text-ink">
            {formatNumber(data.rewarded, language)}
          </dd>
        </div>
        <div>
          <dt className="text-[0.6rem] uppercase tracking-wider text-ink-faint">
            {t('referral.reward')}
          </dt>
          <dd className="mt-0.5 text-base font-semibold">{reward ?? '—'}</dd>
        </div>
      </dl>
    </Card>
  );
}
